import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  public cloneAbstractControl<T extends AbstractControl>(control: T): T {
    let newControl: T;

    if (control instanceof FormGroup) {
      const formGroup = new FormGroup({}, control.validator, control.asyncValidator);

      const controls = control.controls;

      Object.keys(controls).forEach((key) => {
        formGroup.addControl(key, this.cloneAbstractControl(controls[key]));
      });

      newControl = formGroup as any;
    } else if (control instanceof FormArray) {
      const formArray = new FormArray([], control.validator, control.asyncValidator);

      control.controls.forEach((formControl) => formArray.push(this.cloneAbstractControl(formControl)));

      newControl = formArray as any;
    } else if (control instanceof FormControl) {
      newControl = new FormControl(control.value, control.validator, control.asyncValidator) as any;
    }

    if (control.disabled) {
      newControl.disable({ emitEvent: false });
    }

    return newControl;
  }

  public compareWithById(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  public compareWithByName(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.name === o2.name : o1 === o2;
  }

  public getSafe(fn, defaultVal) {
    try {
      return fn();
    } catch (e) {
      return defaultVal;
    }
  }

  public setHttpQueryParameters(parameters: { name: string; value: number | string }[]): HttpParams {
    let httpParam = new HttpParams();

    if (parameters) {
      parameters
        .filter((param) => param.value !== null && param.value !== undefined)
        .forEach((param) => {
          httpParam = httpParam.append(param.name, param.value.toString());
        });
    }

    return httpParam;
  }
}
